/* eslint-disable @typescript-eslint/no-explicit-any */

export function ButtonLabel(props: any) {
  return <div style={{
    cursor: 'pointer',
    display: 'flex',
  }} {...props} />;
}
